import * as Sentry from '@sentry/react'
import '@breath-lab/i18n'
import { getServices, setServices } from '@breath-lab/services'
import { initAuthListener, installVisibilityRefresh, configureBreathworksLogger } from '@breath-lab/state'
import { createLogger } from './infra/logger'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './infra/firebase/appCheck'
import { buildServiceContainer } from './infra/services/buildServiceContainer'
import { bootstrapUser, teardownUser } from './ui/bootstrap'
import './index.css'
import '@ui/styles/global.css'
import App from './App'

setServices(buildServiceContainer())
configureBreathworksLogger(createLogger('@breath-lab/state'))
installVisibilityRefresh(
  (cb) => document.addEventListener('visibilitychange', cb),
  () => document.visibilityState === 'visible',
)
// RC bootstrap: the web SDK needs an appUserId at configure time, so this
// only stashes the key — the real Purchases.configure happens on the first
// logIn(uid) inside the auth listener. Keyless dev builds skip RC entirely
// (revenueCatEnabled false) instead of failing every purchase attempt.
const revenueCatApiKey = import.meta.env.VITE_REVENUECAT_API_KEY as string | undefined
if (revenueCatApiKey) getServices().purchases.configure(revenueCatApiKey)
initAuthListener({
  revenueCatEnabled: !!revenueCatApiKey,
  onSignedIn: bootstrapUser,
  onSignedOut: teardownUser,
})

window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  if (
    error instanceof Error &&
    (error.name === 'ChunkLoadError' ||
      error.message.includes('Failed to fetch dynamically imported module') ||
      error.message.includes('Importing a module script failed'))
  ) {
    window.location.reload();
  }
});

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Privacy Policy states error reports contain no PII — do not send IP/headers
  sendDefaultPii: false,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)
